// src/app/core/pwa/components/pwa-prompt/pwa-prompt.component.ts

import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';

import { IonModal, IonIcon } from '@ionic/angular';
import { addIcons } from 'ionicons';
import {
  closeOutline,
  downloadOutline,
  flashOutline,
  phonePortraitOutline,
  syncOutline,
} from 'ionicons/icons';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PwaService } from '../../services/pwa.service';
import { PwaPromptStatus } from '../../interfaces/pwa.interface';

@Component({
  selector: 'app-pwa-prompt',
  templateUrl: './pwa-prompt.component.html',
  styleUrls: ['./pwa-prompt.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonModal, IonIcon]
})
export class PwaPromptComponent implements OnInit, OnDestroy {
  private pwaService = inject(PwaService);
  private cdr = inject(ChangeDetectorRef);

  private destroy$ = new Subject<void>();
  
  showPrompt = false;
  isInstalling = false;
  
  // Enum para usar no template
  PwaPromptStatus = PwaPromptStatus;

  constructor() {
    addIcons({
      closeOutline,
      downloadOutline,
      flashOutline,
      phonePortraitOutline,
      syncOutline,
    });
  }

  ngOnInit(): void {
    this.subscribeToPromptStatus();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Subscreve ao status do prompt
   */
  private subscribeToPromptStatus(): void {
    this.pwaService.promptStatus$
      .pipe(takeUntil(this.destroy$))
      .subscribe(status => {
        this.showPrompt = status === PwaPromptStatus.VISIBLE;
        this.isInstalling = status === PwaPromptStatus.INSTALLING;
        this.cdr.markForCheck();
      });
  }

  /**
   * Instala o PWA
   */
  async onInstall(): Promise<void> {
    try {
      this.isInstalling = true;
      const outcome = await this.pwaService.showInstallPrompt();
      console.log('PWA installation outcome:', outcome);
    } catch (error) {
      console.error('Error installing PWA:', error);
      this.isInstalling = false;
      this.cdr.markForCheck();
    }
  }

  /**
   * Chamado quando o ion-modal termina de fechar (backdrop ou isOpen=false).
   * Só descarta se o fechamento veio do backdrop (prompt ainda visível).
   */
  onDidDismiss(): void {
    if (this.showPrompt) {
      this.onDismiss();
    }
  }

  /**
   * Descarta o prompt temporariamente
   */
  onDismiss(): void {
    this.pwaService.dismissPrompt();
  }

  /**
   * Descarta o prompt permanentemente
   */
  onClose(): void {
    this.pwaService.permanentlyDismiss();
  }
}
